// Dependencies
import styled from 'styled-components';

const TwoColumnLargeStyles = styled.section`
  color: ${(props) =>
    props?.bgColor === 'bark' || props?.bgColor === 'charcoal'
      ? '#fff'
      : 'var(--color-charcoal)'};
  background-color: var(--color-${(props) => props?.bgColor});

  .row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 0 4rem;
    padding: 3rem 2rem;

    .column {
      width: 100%;
      margin: 0 0 2rem;

      .heading {
        width: 100%;
      }

      .btn-group {
        margin: 2rem 0 4rem 0;
      }

      .img {
        width: 100%;
      }

      &.img-column {
        order: 1;
        margin-bottom: 1.5rem;
      }

      &.text-column {
        order: 2;
        margin-bottom: 0;

        .btn-group {
          margin-bottom: 0;
        }
      }
    }

    &:last-child {
      margin: 0;
    }
  }

  @media (min-width: 992px) {
    .row {
      align-items: center;
      margin: 0 0 ${(props) => (props?.spaceBetweenRows ? '4rem' : 0)};
      padding: 0;

      &:last-child {
        margin: 0;
      }

      .column {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        justify-content: center;
        align-self: stretch;
        width: 50%;
        margin: 0;
        padding: 4rem 3rem;

        .img {
          align-self: ${(props) =>
            props?.fullHeightImg ? 'stretch' : 'initial'};
          height: ${(props) => (props?.fullHeightImg ? '100%' : 'auto')};
          min-height: ${(props) => (props?.fullHeightImg ? '50vh' : '25rem')};
        }

        .btn-group {
          margin: 2rem 0 0;
        }

        &.first {
          order: 1;
        }

        &.second {
          order: 2;
        }

        &.img-column {
          display: flex;
          padding: ${(props) =>
              props?.fullHeightImg || !props?.spaceBetweenRows ? 0 : '5rem'}
            0;

          & > * {
            width: 100%;
            height: 100%;
          }

          &:last-child {
            margin: 0;
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    .row {
      .column {
        .img {
          min-height: ${(props) => (props?.fullHeightImg ? '100vh' : '30rem')};
        }
      }
    }
  }

  @media (min-width: 1200px) {
    .row {
      .column {
        &.text-column {
          padding: 5rem 7.5rem;
        }

        &.img-column {
          display: flex;
          padding: ${(props) =>
              props?.fullHeightImg || !props?.spaceBetweenRows ? 0 : '6rem'}
            0;
        }
      }
    }
  }

  @media (min-width: 1600px) {
    .row {
      .column {
        &.text-column {
          padding: 5rem 10rem;
        }
      }
    }
  }
`;

export default TwoColumnLargeStyles;
